import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import "../userDashboard.css";
import SearchComponent from "../../../components/sharedcomponents/SearchComponent";
import AdvancedSearch from "../../../components/BookComponents/AdvanceSearch";

export const UserSearchPage = () => {

  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar displayType="logo" showNotification showProfileBtn></TopBar>
        <AdvancedSearch></AdvancedSearch>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserSearchPage;
